export default __webpack_public_path__ + "static/media/shutterstock_152639936_VIDEOS_small.419f2ec6.webp";